var QF_CONST = {
    STYLE: 'background: white; color:blue;',
    STYLE_OK: 'background: green; color:white;',
    STYLE_WARN: 'background:red; colour:white;'
};
var QF_FIELDS = QF_FIELDS ? QF_FIELDS : {};
QF_FIELDS.US = {
    QUESTION_TYPE1: 'tx_forms_quoteformus[object][question1]',
    QUESTION_TYPE2: 'tx_forms_quoteformus[object][question2]',
    QUESTION_TYPE3: 'tx_forms_quoteformus[object][question3]',
    QUESTION_TYPE4: 'tx_forms_quoteformus[object][question4]',

    OCCASIONAL_CHARTER: 'tx_forms_quoteformus[object][occasional]',
    RACES: 'tx_forms_quoteformus[object][races]',
    CREW: 'tx_forms_quoteformus[object][crew]',
    LOCATION: 'tx_forms_quoteformus[object][location]',

    VALUE_GROUP: 'yachtInsuranceValue',
    TRAINING_GROUP: 'fieldsTrainingExperience',
    QUOTE_GROUP: 'quotationAreaGroup'
};
var QF_EVENTS = QF_EVENTS ? QF_EVENTS : {};
QF_EVENTS.US = {
        step1: "us_quote_step_personaldata",
        step2: "us_quote_step_boatdata",
        step3: "us_quote_step_coverage",
        step4: "us_quote_step_summary",
        confirm: "us_quote_step_confirmation"
};

if( typeof logForm !== ('object' || 'function') ) {
    function logForm(message, data, style) {
        var dataVars = data || false;
        var stylenamestub = 'STYLE';
        style = style ? stylenamestub+'_'+style : stylenamestub;
        if (window._pants && "dev" === window._pants.env) {
            console.groupCollapsed('%c' + message, QF_CONST[style]);
            dataVars && console.log('data: ',dataVars);
            console.trace('trace:');
            console.groupEnd();

        }
    }
}


var quoteFormUS;
quoteFormUS = function ($) {
    return {
        $form: undefined,
        qf_init_wait_count: 0,
        initForm: function($form) {
             this.$form = $form;
             var formContext = this;

             if ($form.length) {
                 logForm("quote_US_form_test",false, 'WARN');

                 this.$form.find('.quof-progressBlock').hide();

                 this.$form.find('#quof-progressBlock1').show().addClass('active');
                 this.$form.find('*[data-block-id="quof-progressBlock1"]').show().addClass('active');

                 this.initQuoteFormButtons();


                 this.initSwitchFields();
                 var $valueGroup = this.$form.find('.{1}'.replace('{1}', QF_FIELDS.US.VALUE_GROUP));
                 this.$form.find("."+ QF_FIELDS.US.VALUE_GROUP, '[name="{1}"]'.replace('{1}', QF_FIELDS.US.CURRENCY_NAME)).on("change keyup click", function(){
                     formContext.updateSumGroup($form, ".yachtValueGroup");
                 });

                 this.$form.find('[name="{1}"]'.replace('{1}', QF_FIELDS.US.CURRENCY_NAME)).on('click', function () {
                     if($valueGroup.length) {
                         $valueGroup.prop('disabled', false);
                     }
                     var currency = formContext.getSelectedCurrency();
                     $('.valueGroupCurrencyLabel').html(currency.symbol);
                     formContext.updateSumGroup($form, ".yachtValueGroup");
                 });
                 var context = this;
                 var trackStep  = function() {
                     if(window.dataLayer && window.dataLayer.length) {
                         trackEvent(QF_EVENTS.US.step1);
                     } else {
                         if(context.qf_init_wait_count<4) {
                             // console.log('waiting...');
                             setTimeout(trackStep, 2500);
                             context.qf_init_wait_count++;
                         }
                     }
                 };
                 trackStep();
                 this.initQuoteFormSubmit();
             }
        },
        initQuoteFormButtons: function(){
            var $form = this.$form;
            var formContext = this;

            this.$form.find(".buttonPrev").unbind().click(function () {
                logForm("qf prev");
                var prev = $form.find(".progressViewElement.active").prev();
                formContext.quoteFormStep(prev, false);
            });
            this.$form.find(".buttonNext").unbind().click(function () {
                logForm("qf next");
                var $current = $form.find(".progressViewElement.active");
                var $next = $current.next();
                if( formContext.quoteFormStep($next, true) && ($current.data('step') > $form.data('stepCompleted') ) ) {
                    $form.data('stepCompleted', $current.data('step'))
                }

            });
            this.$form.find(".buttonPrev").on("keydown", handleKeyDownForClick);
            this.$form.find(".buttonNext").on("keydown", handleKeyDownForClick);

            this.$form.find(".summaryChangeButton").click(function(e){
                e.preventDefault();
                var id = parseInt($(this).attr("data-id"))-1;
                var targetStep =  $form.find(".progressViewElement").eq(id);
                formContext.quoteFormStep(targetStep , false);
            });
            this.$form.find(".summaryChangeButton").on("keydown", handleKeyDownForClick);
        },
        quoteFormStep: function($progressElement, validate){
            var formValid = true;
            if (validate) {
                formValid = this.validateQuoteForm(this.$form.find('.quof-progressBlock.active'));
            }

            //formValid = true;

            if (validate && formValid) {
                logForm("form validated");

                this.initQuoteFormButtons();

                this.updateQuoteFormSummary();

                // updateRacingYachtInsuranceHullValue();

            }  else if(validate && !formValid) {
                logForm("form validation error");
                scrollToError();
                // validation error!
            }

            if (formValid) {
                var blockId = $progressElement.attr("data-block-id");
                this.$form.find(".progressViewElement").removeClass("active");
                $progressElement.addClass("active");
                $progressElement.removeClass("disabled");
                this.$form.find(".quof-progressBlock").hide().removeClass("active");
                this.$form.find("#" + blockId).show().addClass("active");

                $('html, body').animate({
                    scrollTop: $progressElement.offset().top - 60
                }, 100);

                var stepEvent = "";
                switch($progressElement.index()) {
                    case 0:
                        stepEvent = QF_EVENTS.US.step1;
                        break;
                    case 1:
                        stepEvent = QF_EVENTS.US.step2;
                        break;
                    case 2:
                        stepEvent = QF_EVENTS.US.step3;
                        break;
                    case 3:
                        stepEvent = QF_EVENTS.US.step4;
                        break;
                    default:
                }

                trackEvent(stepEvent, null );
                return stepEvent;
            }
            return false;
        },
        validateQuoteForm: function($formStep){
            var $currentBlock = $formStep;
            var formContext = this;
            //testing!
            // return true;
            //testing!

            var error = false;

            $currentBlock.find("input").each(function () {
                if (formContext.validateFormField($(this))) {
                    error = true;
                }
            });
            $currentBlock.find("textarea").each(function () {
                if (formContext.validateFormField($(this))) {
                    error = true;
                }
            });
            $currentBlock.find("select").each(function () {
                if (formContext.validateFormField($(this))) {
                    error = true;
                }
            });

            if(this.$form.data('stepCompleted') > 0) {
                var hasCrew = $('[name="'+QF_FIELDS.US.CREW+'"]:checked');
                error = this.validateCheckboxGroup(hasCrew, 'formFieldHasCrew', error);
            }

            if(this.$form.data('stepCompleted') > 1) {

                var felonyCheck = $('[name="' + QF_FIELDS.US.QUESTION_TYPE2 + '"]:checked');
                error = this.validateCheckboxGroup(felonyCheck, 'formFieldFelonyConviction', error);

                var duiCheck = $('[name="' + QF_FIELDS.US.QUESTION_TYPE3 + '"]:checked');
                error = this.validateCheckboxGroup(duiCheck, 'formFieldDUI', error);

                var declinedCheck = $('[name="' + QF_FIELDS.US.QUESTION_TYPE4 + '"]:checked');
                error = this.validateCheckboxGroup(declinedCheck, 'formFieldDenied', error);
            }

            return !error;
        },
        validateCheckboxGroup: function($checkfield, formFieldId, error){
            if (!$checkfield.length) {
                error = true;
                $("#"+formFieldId).addClass("error");
                $("#" + formFieldId + " .errormessage").show();
            } else {
                $("#"+formFieldId).removeClass("error");
                $("#" + formFieldId + " .errormessage").hide();
            }

            return error;
        },
        updateQuoteFormSummary: function(){
//add value to summary
              var formContext = this;
              this.$form.find(".summaryData").each(function(){
                  var id = $(this).attr("data-summary-id");
                  var field = formContext.$form.find("#"+id);
                  var value = "";

                  if($(this).is("input")){
                      value = $(this).val();

                      if($(this).hasClass("yachtInsuranceValue")){
                          var cur = formContext.getSelectedCurrency();
                          value = cur.symbol + " " + $(this).val();
                      }
                  }
                  else if($(this).is("select")){
                      value = $(this).val();
                      if("selectboxGender" === this.id) {
                          value = $(this).find('option[value="'+$(this).val()+'"]').html()
                      }
                  }
                  else if($(this).is("textarea")){
                      value = $(this).val();
                  }

                  if(value === ""){
                      value = "-"
                  }

                  field.html(value);
              });

              var occasionalCharter = $('[name="'+QF_FIELDS.US.OCCASIONAL_CHARTER+'"]:checked');
              if ( occasionalCharter.length ) {
                  var occasionalCharterSelected = parseInt(occasionalCharter.val());
                  $('#quof-summary-occasionalCharter .checkboxFlag').removeClass('checked');
                  occasionalCharterSelected ? $('#quof-summary-occasionalCharter .flagYes').addClass('checked') : $('#quof-summary-occasionalCharter .flagNo').addClass('checked')
              }
              var races = $('[name="'+QF_FIELDS.US.RACES+'"]:checked');
              if ( races.length ) {
                  var racesSelected = parseInt(races.val());
                  $('#quof-summary-participateRaces .checkboxFlag').removeClass('checked');
                  racesSelected ? $('#quof-summary-participateRaces .flagYes').addClass('checked') : $('#quof-summary-participateRaces .flagNo').addClass('checked')
              }

              var crew = $('[name="'+QF_FIELDS.US.CREW +'"]:checked');
              if ( crew.length ) {
                  var crewSelected = crew.val().toLowerCase();
                  $('#quof-summary-crew .checkboxFlag').removeClass('checked');
                  crewSelected === "yes"  ? $('#quof-summary-crew .flagYes').addClass('checked') : $('#quof-summary-crew .flagNo').addClass('checked')
              }

              var $crewSummary = $('.summaryCrew');
              $crewSummary.hide();
              if (crew.length && (crew.val().toLowerCase() === 'yes') ) {
                  $crewSummary.show();
              } else {
                  $crewSummary.hide()
              }

            //<editor-fold desc="Radio button fields">
            var question1 = $('[name="'+QF_FIELDS.US.QUESTION_TYPE1+'"]:checked');
            if ( question1.length ) {
                var question1Selected = parseInt(question1.val());
                $('#quof-summary .checkboxFlag').removeClass('checked');
                question1Selected ? $('#quof-summary-quoteConfiscation .flagYes').addClass('checked') : $('#quof-summary-quoteConfiscation .flagNo').addClass('checked')
            }

            var question2 = $('[name="'+QF_FIELDS.US.QUESTION_TYPE2+'"]:checked');
            if ( question2.length ) {
                var question2Selected = parseInt(question2.val());
                $('#quof-summary-felonyConviction .checkboxFlag').removeClass('checked');
                question2Selected ? $('#quof-summary-felonyConviction .flagYes').addClass('checked') : $('#quof-summary-felonyConviction .flagNo').addClass('checked')
            }

            var question3 = $('[name="'+QF_FIELDS.US.QUESTION_TYPE3+'"]:checked');
            if ( question3.length ) {
                var question3Selected = parseInt(question3.val());
                $('#quof-summary-DUI .checkboxFlag').removeClass('checked');
                question3Selected ? $('#quof-summary-DUI .flagYes').addClass('checked') : $('#quof-summary-DUI .flagNo').addClass('checked')
            }

            var question4 = $('[name="'+QF_FIELDS.US.QUESTION_TYPE4+'"]:checked');
            if ( question4.length ) {
                var question4Selected = parseInt(question4.val());
                $('#quof-summary-denied .checkboxFlag').removeClass('checked');
                question4Selected ? $('#quof-summary-denied .flagYes').addClass('checked') : $('#quof-summary-denied .flagNo').addClass('checked')
            }
            //</editor-fold>

            var fieldsTrainingExperienceArray = [];
            $('#fieldsTrainingExperience').find('input:checked').each(function (idx, el) {
                fieldsTrainingExperienceArray.push($(el).siblings('label').html())
            });
            $('#quof-summary-trainingExperience').html(fieldsTrainingExperienceArray.join(', '));

              var quoteAreaStringArray = [];
              $('#quotationAreaGroup').find('input:checked').each(function (idx, el) {
                  quoteAreaStringArray.push($(el).siblings('label').html())
              });

              $('#quof-summary-cruisingArea').html(quoteAreaStringArray.join(', '));
          },
        validateFormField: function($ff){
            return getRacingYachtInsuranceFormFieldError($ff);
        },
        initSwitchFields: function(){
                 var $switchFields = this.$form.find('*[data-switch-container-id]');
                 var formContext = this;
                 logForm("switch field: ", $switchFields, 'OK');

                 $switchFields.hide();
                 $switchFields.each(function (index, switchField) {
                     var $switchField = $(switchField);
                     var switchId = $switchField.data('switch-container-id');
                     // logForm("switch field id: " + switchId);
                     formContext.$form.find('*[data-switch-container-on="'+switchId+'"]').click(function(){
                         $switchField.show();
                         $switchFields.find('input, textarea').prop('disabled', false);
                         // logForm("form switch on event attached - id:" + switchId);
                     });

                     formContext.$form.find('*[data-switch-container-off="'+switchId+'"]').click(function(){
                         $switchField.hide();
                         $switchFields.find('input, textarea').prop('disabled', true);
                         // logForm("form switch off event attached - id:" + switchId);
                     });
                 });

                 var $locationSelect = $('[name="'+QF_FIELDS.US.LOCATION+'"]');
                 var $marinaFields = $('#marinaRows');
                 var $marinaSummary = $('#marinaAddressField');
                 $locationSelect.on('change', function () {
                     var val = $(this).find('option:selected').val();

                     if("Marina-Other" === val) {
                         $marinaFields.show();
                         $marinaSummary.show();
                     } else {
                         $marinaFields.hide();
                         $marinaSummary.hide();
                     }
                 })

             },
        updateSumGroup: function(){
               var currency = this.getSelectedCurrency();

               var sum = this.getQuoteFormInsuranceSum();

               if(sum > 0){
                   this.$form.find('.{1}Sum'.replace('{1}', QF_FIELDS.US.VALUE_GROUP)).html(currency.symbol + " " + sum);
                   this.$form.find("#quof-summary-boatTotalSum").html(sum + " "+ currency.symbol);

                   // this.$form.find('.{1}Sum'.replace('{1}', QF_FIELDS.US.VALUE_GROUP)).val(currency.symbol + " " + sum);
                   this.$form.find('.{1}Sum'.replace('{1}', QF_FIELDS.US.VALUE_GROUP)).val(sum);
               }
               else{
                   this.$form.find('.{1}Sum'.replace('{1}', QF_FIELDS.US.VALUE_GROUP)).html("");
                   this.$form.find("#quof-summary-boatTotalSum").html("");

                   this.$form.find('.{1}SumInput'.replace('{1}', QF_FIELDS.US.VALUE_GROUP)).val(0);
               }
           },
        getQuoteFormInsuranceSum: function(){
                var sum = 0;
                this.$form.find('.{1}'.replace('{1}', QF_FIELDS.US.VALUE_GROUP) ).each(function(){
                    if($(this).val() !== ""){
                        sum += parseInt($(this).val());
                    }
                });
                return sum;
            },
        getSelectedCurrency: function(){
            // var currencyChecked = this.$form.find('[name="{1}"]:checked'.replace('{1}', QF_FIELDS.US.CURRENCY_NAME));
            // var currencySelected = currencyChecked.length ? currencyChecked.val() : "EUR";
            var curVals = {
                'EUR' : {
                    symbol:"€",
                    locale: "de-DE",
                    code:"EUR"
                },
                'PLN' : {
                    symbol:"zł",
                    locale: "pl-PL",
                    code:"PLN"
                },
                'USD' : {
                    symbol:"$",
                    locale: "en-US",
                    code:"USD"
                },
            };
            return curVals['USD'];
        },
        initQuoteFormSubmit: function(){
                var formContext = this;
                var $terms1 = this.$form.find("#checkboxConditionsField");

                this.$form.find('*[type="submit"]').click(function (e) {
                    e.preventDefault();
                    var termsAgreed = true;

                    if(!$terms1.find('input:checked').length ) {
                        // terms1 not checked
                        termsAgreed = false;
                        $terms1.addClass('error');

                    }

                    if(termsAgreed) {
                        // var expires = new Date(new Date().getTime() + 5 * 60 * 1000); // 5 minutes
                        // var trackingData = {"currencyCode": this.getSelectedCurrency().code};
                        // var args = [QF_EVENTS.PL.confirm, this.getQuoteFormInsuranceSum($form), trackingData];
                        // var data = {"args": args, "fn": "trackEvent"};
                        // cookieSet('tracking_nonce', data, expires);

                        formContext.$form.submit();
                    } else {
                        scrollToError();
                    }
                });
                this.$form.find('*[type="submit"]').on("keydown", handleKeyDownForClick);
            },
    };

};

function initUSQuoteForm() {
     quoteFormUS(jQuery).initForm($("#quotationFormUS"));
}
